import { createReducer } from '@reduxjs/toolkit';
import {
    SET_RATING, SET_SETTING_RATING, UNSET_SETTING_RATING,
} from '../actions/RatingActions';

const initialState = {
    musicHash: null,
    rating: null,
    settingRating: false,
};

const rating = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_RATING, (state, action) => {
            state.rating = action.rating;
            state.musicHash = action.musicHash;
        })
        .addCase(SET_SETTING_RATING, (state) => {
            state.settingRating = true;
        })
        .addCase(UNSET_SETTING_RATING, (state) => {
            state.settingRating = false;
        });
});

export default rating;
